module.exports = __webpack_public_path__ + "static/img/login-input-bg.eafac4c2.png";